import { render, staticRenderFns } from "./StatementSidebar.vue?vue&type=template&id=256746a6&"
import script from "./StatementSidebar.vue?vue&type=script&lang=js&"
export * from "./StatementSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256746a6')) {
      api.createRecord('256746a6', component.options)
    } else {
      api.reload('256746a6', component.options)
    }
    module.hot.accept("./StatementSidebar.vue?vue&type=template&id=256746a6&", function () {
      api.rerender('256746a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-statement/StatementSidebar.vue"
export default component.exports